import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type StateService from 'garaje/services/state';
import urlBuilder from 'garaje/utils/url-builder';

import type LocationOverviewHrisNotificationsController from './controller';
import type { NotificationsModel } from './controller';

export default class LocationOverviewHrisNotificationsRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;
  @service declare state: StateService;

  async model(): Promise<NotificationsModel> {
    try {
      return await this.ajaxFetch.request(
        urlBuilder.hrisLifecycle.url(`/notifications?company_id=${this.state.currentCompany.id}`),
      );
    } catch (err) {
      // Don't crash the tab if settings can't be loaded (authz / transient error) —
      // setupFromModel falls back to DEFAULT_STATE when `notifications` is absent.
      // eslint-disable-next-line no-console
      console.error('[hris-notifications] failed to load notification settings:', err);
      return {};
    }
  }

  setupController(
    controller: LocationOverviewHrisNotificationsController,
    model: NotificationsModel,
    transition: Transition<unknown>,
  ): void {
    super.setupController(controller, model, transition);
    controller.setupFromModel();
  }
}
